<template>
  <MainTab
    v-if="registrationIsLoaded"
    :main-title="`${activeRegistration().linked_event.type_label} ${activeRegistration().linked_event.title}`"
  >
    <ContentWrapper>
      <template #default>
        <TicketCard
          :registration="activeRegistration()"
          @registrationDetail="focusRegistration(registration)"
          @editLaboratories="editLaboratories(registration)"
          @completeSurvey="completeSurvey(registration)"
          @downloadFiles="downloadFiles(registration)"
          @cancelRegistration="triggerRegistrationCancel(registration)"
        ></TicketCard>
      </template>
    </ContentWrapper>
  </MainTab>
  <Loader v-else></Loader>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/elements/Loader";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import MainTab from "~/components/events/components/MainTab";
import TicketCard from "~/components/events/components/TicketCard";

export default {
  name: "EventsSelectedEvent",
  components: {
    MainTab,
    ContentWrapper,
    TicketCard,
    Loader,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["activeRegistration", "registrationIsLoaded"]),
  },
  mounted() {
    this.fetchRegistration({ registrationId: this.$route.params.registration, force: false });
  },
  beforeDestroy() {
    this.$store.commit("updateRegistrationLoading", false);
  },
  methods: {
    ...mapActions(["fetchRegistration"]),
    // back() {
    //   this.$router.push({ name: "home" });
    // },
  },
};
</script>
